import { CountdownTimer, Grid, Heading, Loader } from '@afterpaytouch/core'
import React, { FunctionComponent, useEffect } from 'react'
import { useCheckoutSizes } from '../../utils/responsive'
import { useTranslation } from '../../utils/convergence'
import { FormWrapper } from '../FormWrapper'
import { ProfileCard } from '../ProfileCard'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { useConsumerSelector } from '../../state'
import { maskPhoneNumber } from '../../utils/phone-numbers'
import { maskEmail } from '../../utils/emails'
import { TrackingEvent } from '../../model/monitoring'
import { useProfileCardProps } from './hooks'
import styles from './styles.module.css'

export const Verifying: FunctionComponent<{ allowLogout: boolean; isRevealMobile: boolean; delayMs: number }> = ({ allowLogout, isRevealMobile, delayMs }) => {
  const { t } = useTranslation()
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const { mobile, email } = useConsumerSelector()
  const profileCardProps = useProfileCardProps()
  const [timer, setTimer] = React.useState<number>(0)
  const isSMSVerifyingPage = delayMs > 0

  useEffect(() => {
    if (isSMSVerifyingPage) {
      logEvent(TrackingEvent.VIEWED_SMS_VERIFYING_PAGE, {
        mobile: maskPhoneNumber(mobile),
        email: maskEmail(email),
      })
    }
  }, [isSMSVerifyingPage])

  useEffect(() => {
    setTimer(delayMs)
  }, [delayMs])

  const { headingSize, textSize } = useCheckoutSizes()
  const testNameSpace = 'verifying'

  return (
    <>
      {isSMSVerifyingPage ? (
        <>
          <Grid>
            <Heading size={headingSize}>{t('verify:verifying.title')}</Heading>
          </Grid>
          <FormWrapper>
            <ProfileCard allowLogout={allowLogout} revealMobile={isRevealMobile} {...profileCardProps} />
            <div className={styles.loaderWrapper}>
              <CountdownTimer
                t={t}
                textSize={textSize}
                loaderText={`verify:verifying.info`}
                loaderTimeSecondsAndMinutes={'verify:verifying.detailSecondsAndMinutes'}
                loaderTimeSeconds={'verify:verifying.detailSeconds'}
                time={timer}
                testNameSpace={testNameSpace}
              />
            </div>
          </FormWrapper>
        </>
      ) : (
        <div className={styles.loaderWrapper}>
          <Loader testNameSpace={testNameSpace} />
        </div>
      )}
    </>
  )
}
